import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import FormTitle from 'components/fulcrum/formTitle/FormTitle'
import { Creatable } from 'react-select'
import styles from './styles.scss'

const DropdownCreatable = (props) => {
  const { title, source, values, onChange, multiSelectable } = props
  return (
    <div styleName='container'>
      <FormTitle title={title}>
        <Creatable
          isClearable
          styleName='select'
          options={source}
          value={values}
          multi={multiSelectable}
          onChange={onChange}
        />
      </FormTitle>
    </div>
  )
}

export default CSSModules(styles)(DropdownCreatable)
